<template>
  <label class="worker-checkbox" :class="{table}">
    <input
        type="checkbox"
        :checked="value"
        ref="check"
        @input="$emit('input', $event.target.checked); $emit('change', $event)"
        :disabled="disabled"
    >
    <span class="checkmark" :class="{white}"></span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: "app-checkbox",
  props:{
    value:{
      type: [Boolean, Number],
      default: false
    },
    disabled:{
      type: Boolean,
      default: false
    },
    white:{
      type: Boolean,
      default: false
    },
    indeterminate:{
      type: Boolean,
      default: false
    },
    table:{
      type: Boolean,
      default: false
    },
  },
  mounted () {
    this.$refs.check.indeterminate = this.indeterminate;
  },
  watch:{
    indeterminate(n){
      this.$refs.check.indeterminate = n;
    }
  }
}
</script>

<style scoped lang="scss">
.worker-checkbox {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 35px;
  margin: 10px 0 12px 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #7A818F;

  &.table{
    padding-left: unset;
    margin: unset;
    width: 19px;
    height: 19px;
  }
}
.worker-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkmark {
  position: absolute;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #faf7f7;
  //box-shadow: 0px 0px 3px #000000;
  border: 1px solid #B6BCC8;
  border-radius: 4px;
  transition: background-color .25s;

  &.white{
     //left: -3px;
     //top: -5px;
     background-color: #ffffff;
     border: 1px solid #B6BCC8;
   }
}
.worker-checkbox:hover input ~ .checkmark {
  background-color: #ccc;
}
.worker-checkbox:hover input ~ .checkmark.white {
  background-color: #eee;
}

.worker-checkbox input:checked ~ .checkmark, .worker-checkbox input:indeterminate ~ .checkmark,
.worker-checkbox input:checked ~ .checkmark.white, .worker-checkbox input:indeterminate ~ .checkmark.white {
  background-color: #2CB181;
}
.checkmark:after {
  content: "";
  position: absolute;
  opacity: 0;
}
.worker-checkbox input:checked ~ .checkmark:after,
.worker-checkbox input:checked ~ .checkmark.white:after {
  transform: rotate(45deg) scaleY(1) !important;
  opacity: 1;
}

.worker-checkbox input:indeterminate ~ .checkmark:after,
.worker-checkbox input:indeterminate ~ .checkmark.white:after, {
  transform: scaleY(1) !important;
  opacity: 1;
}
.worker-checkbox .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(20deg) scaleY(0.9);
  transition: transform .25s ;
}
.worker-checkbox input:checked ~ .checkmark.white:after {
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(20deg) scaleY(0.9);
  transition: transform .25s;
  transform-origin: center;
}
.worker-checkbox input:indeterminate ~ .checkmark:after {
  left: 20%;
  right: 20%;
  top: 50%;
  width: unset;
  height: 2px;
  border-width: 0 0 2px 0 ;
  -webkit-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  transform: rotate(0deg);
}
</style>
